
export default function Footer() {
  return (
    <footer className="bg-[#0F5E7E] text-white py-12 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/a4bf84dbd5adba3766c3686d81e98326/c3e292b273dac3f60365668f88cc8618.png" 
              alt="Plomb'ART Logo" 
              className="w-32 h-32 object-contain mb-4"
            />
            <p className="text-white/80 leading-relaxed">
              L'art du chaud et du froid.<br />
              Plomberie professionnelle à Lyon.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Nos services</h3>
            <ul className="space-y-2 text-white/80">
              <li className="hover:text-white transition-colors cursor-pointer">Installation salle de bains</li>
              <li className="hover:text-white transition-colors cursor-pointer">Chauffe-eau</li>
              <li className="hover:text-white transition-colors cursor-pointer">Réparation de fuites</li>
              <li className="hover:text-white transition-colors cursor-pointer">Dépannage urgent</li>
              <li className="hover:text-white transition-colors cursor-pointer">Rénovation sanitaire</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-center gap-2">
                <i className="ri-phone-fill text-[#F5A623]"></i>
                <a href="tel:0762551412" className="hover:text-white transition-colors cursor-pointer">07 62 55 14 12</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-fill text-[#F5A623]"></i>
                <a href="mailto:contacts@plomb-art.fr" className="hover:text-white transition-colors break-all cursor-pointer">contacts@plomb-art.fr</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-fill text-[#F5A623] mt-1"></i>
                <span>30 avenue Maréchal Foch<br />Bureau 3, 69006 LYON</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © 2025 PLOMB'ART. Tous droits réservés.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
